module.exports = __webpack_public_path__ + "media/src/assets/Images/Insurance-22a3d2a41145d7dfbb4c06d6e7915889.svg";